import React from "react";

const LogoSVG = ({ w, h }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}`}
      height={`${h}`}
      viewBox="0 0 300.000000 172.000000"
      preserveAspectRatio="none"
      className="block"
    >
      <g
        transform="translate(0.000000,172.000000) scale(0.100000,-0.100000)"
        /* fill="#f0ebd4" */
        fill="#ff3d00"
        stroke="none"
      >
        <path
          d="M874 1440 c-318 -263 -339 -282 -342 -315 l-3 -35 153 127 c84 71
244 203 356 296 140 115 202 173 202 187 0 11 -6 20 -13 20 -8 0 -166 -126
-353 -280z"
        />
        <path d="M10 875 l0 -835 25 0 25 0 0 835 0 835 -25 0 -25 0 0 -835z" />
        <path d="M190 875 l0 -835 25 0 25 0 0 835 0 835 -25 0 -25 0 0 -835z" />
        <path d="M360 875 l0 -835 30 0 30 0 0 835 0 835 -30 0 -30 0 0 -835z" />
        <path
          d="M1810 1699 c-75 -15 -168 -67 -229 -128 -98 -99 -141 -208 -141 -358
0 -82 0 -83 25 -83 24 0 25 2 25 78 1 93 12 147 47 218 44 91 126 164 233 210
40 17 79 19 365 24 l320 5 -50 19 c-44 17 -80 20 -300 22 -137 1 -270 -2 -295
-7z"
        />
        <path
          d="M2870 1621 c0 -49 -3 -96 -6 -105 -5 -13 2 -16 36 -16 34 0 41 3 36
16 -3 9 -6 56 -6 105 l0 89 -30 0 -30 0 0 -89z"
        />
        <path
          d="M1860 1521 c-87 -27 -166 -96 -202 -179 -13 -28 -22 -77 -26 -129
l-5 -83 27 0 c25 0 26 3 26 50 0 124 43 208 135 265 l48 30 379 3 c208 2 378
5 378 8 0 3 -5 14 -10 25 -10 18 -25 19 -368 18 -196 0 -368 -4 -382 -8z"
        />
        <path
          d="M885 1227 c-325 -268 -350 -292 -353 -323 -3 -34 7 -27 350 257 194
161 354 300 356 311 2 10 2 24 0 31 -2 8 -151 -108 -353 -276z"
        />
        <path
          d="M2800 1315 l0 -105 26 0 c26 0 26 0 22 70 -2 39 -1 70 3 70 3 0 19
-31 34 -70 28 -70 28 -70 67 -70 l38 0 0 105 c0 98 -1 105 -20 105 -18 0 -20
-7 -20 -75 0 -52 4 -75 12 -75 9 0 9 -3 1 -11 -13 -13 -36 -2 -27 12 3 6 -7
41 -23 80 l-28 69 -42 0 -43 0 0 -105z"
        />
        <path
          d="M1903 1334 c-50 -25 -73 -70 -73 -143 0 -58 1 -61 25 -61 24 0 25 3
25 58 0 63 20 96 63 107 12 3 142 5 289 3 l267 -3 31 -30 c42 -40 56 -91 40
-141 -14 -41 -59 -92 -304 -344 -83 -85 -187 -192 -231 -238 l-80 -82 39 2
c36 3 54 19 304 278 146 151 277 292 293 313 52 72 47 165 -14 234 -54 61 -66
63 -369 63 -230 0 -278 -3 -305 -16z"
        />
        <path
          d="M950 1049 c-151 -126 -299 -250 -329 -276 -58 -51 -91 -109 -91 -163
0 -43 29 -108 61 -136 29 -26 637 -464 644 -464 3 0 5 13 5 28 0 25 -31 50
-311 252 -171 123 -318 234 -326 247 -25 38 -27 103 -5 139 11 17 160 147 331
288 280 231 311 260 311 286 0 17 -3 30 -7 29 -5 0 -132 -104 -283 -230z"
        />
        <path
          d="M2099 1163 c-86 -91 -370 -391 -513 -543 -54 -58 -110 -115 -123
-128 -31 -28 -27 -33 20 -25 34 5 73 43 384 372 191 201 352 370 360 374 23
14 14 27 -20 27 -29 0 -44 -11 -108 -77z"
        />
        <path
          d="M2145 935 c-425 -446 -445 -468 -445 -471 0 -1 16 -2 36 -1 29 2 45
13 97 67 463 483 667 699 667 704 0 3 -15 6 -32 6 -30 -1 -60 -30 -323 -305z"
        />
        <path
          d="M2803 1108 c3 -13 13 -60 23 -105 l17 -83 57 0 57 0 17 92 c10 50 20
97 23 105 4 9 -5 13 -30 13 l-34 0 -14 -95 c-7 -52 -16 -95 -19 -95 -4 0 -13
43 -20 95 l-13 95 -34 0 c-31 0 -35 -2 -30 -22z"
        />
        <path
          d="M2830 733 l0 -108 70 -1 c62 -1 70 1 70 17 0 15 -8 19 -40 19 -38 0
-40 2 -40 30 0 28 3 30 35 30 24 0 35 5 35 15 0 10 -11 15 -35 15 -32 0 -35 2
-35 30 0 28 2 30 40 30 29 0 40 4 40 15 0 12 -14 15 -70 15 l-70 0 0 -107z"
        />
        <path
          d="M815 774 c-11 -9 -15 -18 -10 -20 9 -4 97 -65 373 -261 l62 -44 0 33
c-1 31 -10 40 -191 166 -104 73 -195 135 -202 137 -6 2 -21 -3 -32 -11z"
        />
        <path
          d="M676 661 c-16 -18 -6 -27 258 -215 151 -108 278 -201 281 -206 13
-21 26 -8 23 22 -3 30 -21 45 -218 185 -368 262 -325 235 -344 214z"
        />
        <path
          d="M2828 539 c-20 -11 -25 -83 -8 -94 6 -4 32 -12 58 -18 31 -8 48 -18
50 -29 3 -14 -3 -18 -27 -18 -17 0 -31 5 -31 10 0 6 -13 10 -30 10 -25 0 -30
-4 -30 -25 0 -32 26 -45 94 -45 65 0 86 16 86 65 0 39 -8 46 -70 60 -36 8 -46
15 -48 33 -3 20 -1 22 25 16 15 -4 30 -11 31 -16 2 -4 15 -8 28 -8 19 0 24 5
24 25 0 14 -8 29 -19 35 -25 13 -111 13 -133 -1z"
        />
        <path d="M1430 373 l0 -28 622 2 621 3 2 25 1 25 -623 0 -623 0 0 -27z" />
        <path d="M1430 220 l0 -30 623 0 623 0 -2 28 -1 27 -621 3 -622 2 0 -30z" />
        <path
          d="M2810 235 c0 -10 10 -15 31 -15 l31 0 -4 -90 -3 -90 33 0 32 0 0 90
0 90 30 0 c20 0 30 5 30 15 0 12 -17 15 -90 15 -73 0 -90 -3 -90 -15z"
        />
        <path d="M1430 65 l0 -25 623 0 622 0 0 25 0 25 -622 0 -623 0 0 -25z" />
      </g>
    </svg>
  );
};

export default LogoSVG;
